export default __webpack_public_path__ + "static/media/promo_06.11660451.jpg";